<template>
  <div style="display: inline;">
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/basic/material/other/info/page" getKey="rows" :columns="columns">
      <!-- 左侧按钮插槽 -->
      <template #buttonsL="scope">
        <el-button
          type="primary"
          size="mini"
          @click="
            yt.showEditDialog('xinzeng', null, 'w1');
            setAddDefaultValue();
          "
        >
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{ $t('bianji') }} </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" :loading="yt.editObj.loading" class="font-color-danger" @click="yt.remove(scope.row, '/web/basic/material/other/info/delete')">{{ $t('shanchu') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('zhijianguize')" required>
            <el-select v-model="yt.editObj.inspectionRulesId" @change="$forceUpdate()">
              <el-option v-for="(item, index) in inspectionRules" :key="index" :label="item.name" :value="item.id" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('chaoliangjieshouyuncha')">
            <el-input-number class="inputClass" :precision="2" :min="0" v-model="yt.editObj.exceedAcceptDiff"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/basic/material/other/info/create', beforeAdd)" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('zhijianguize')" required>
            <el-select v-model="yt.editObj.inspectionRulesId">
              <el-option v-for="(item, index) in inspectionRules" :key="index" :label="item.name" :value="item.id" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('chaoliangjieshouyuncha')" >
            <el-input-number class="inputClass" :precision="2" :min="0" v-model="yt.editObj.exceedAcceptDiff"></el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="yt.req('POST', '/web/basic/material/other/info/update')" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script type="text/javascript">
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';

export default {
  name: 'web_base_matter_management_style',
  data() {
    return {
      materialList: [],
      materialBatchIdDisabled: true,
      columns: [

        {
          label: 'zhijianguize',
          prop: 'inspectionRules.name'
        },
        {
          label: 'chaoliangjieshouyuncha',
          prop: 'exceedAcceptDiff'
        },
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname'
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          fixed: 'right',
          width: 120
        }
      ],
      inspectionRules:[],
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        materialId: this.$attrs.material.id,
        pageNum: 1,
        pageSize: 100
      };
      this.yt.get(1);
      this.yt.isShowPagination = false;
      //质检规则
      this.http.get("/web/inspection/rules/list").then((res) => {
        this.inspectionRules = res.data;
      })
      //
    }, 300);
  },
  methods: {
    beforeAdd(params, url) {
      params.materialId = this.$attrs.material.id;
      return params;
    },
    setAddDefaultValue() {
      this.yt.editObj.autoInspectionReport = true;
    }
  }
};
</script>

<style scoped lang="scss"></style>
